import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class Newsletter extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get title() {
    return get(this, '_title.value', '');
  }

  get description() {
    return get(this, '_description.value', '');
  }

  get buttonText() {
    return get(this, '_button_text.value', '');
  }

  get label() {
    return get(this, '_label.value', '');
  }

  get htmlModifiers() {
    return get(this, '_html_modifiers', []);
  }
}



// WEBPACK FOOTER //
// ./src/models/Newsletter.model.js